<template>
    <div>
      <app-gridview
        v-bind:parentData="{
          tabHeaders: this.dataHeader,
          tabItems: this.dataItems,
          pageTitle: this.pageTitle,
          search: this.search,
          isAdvanceEdit: true,
          isDelete: true,
        }"
        v-on:AdvanceEditItem="advanceEditItemHandler($event)"
        v-on:EditItem="editItemHandler($event)"
        v-on:DeleteItem="deleteItemHandler($event)"
        v-on:NewPressed="newRecordHandler"
      ></app-gridview>
    </div>
  </template>
<script>
import moment from 'moment';
import GridView from "../../../components/common/GridView";

export default {
  components: {
    "app-gridview": GridView,
  },

  data() {
    return {
      pageTitle: this.$t('appraisalexerciserecords.appraisalexerciselist'),
      dataHeader: [

        { value: "action", sortable: false, width: "150px" },
        { text: this.$t('apprailsalexercise'), value: "reviewcode", sortable: false, width: "100px" },
        { text: this.$t('pmreviewexercise.exercisedesc'), value: "description", width: "200px" },
        { text: this.$t('columns.type'), value: "formtypetext", width: "100px" },
        { text: this.$t('columns.startdate'), value: "startdate", width: "150px" },
        { text: this.$t('columns.enddate'), value: "enddate", width: "150px" },
        { text: this.$t('pmreviewexercise.assessmenttype'), value: "assessmenttext", width: "200px" },
        { text: this.$t('Setuprankmapset.rankmapset'), value: "pmrankmaptext", width: "200px" },
        { text: this.$t('columns.recordsinsharp'), value: "totalRecords", width: "150px" },
        { text: this.$t('pmreviewexercise.initiatedrecords'), value: "initiated", width: "150px" },
        { text: this.$t('pmreviewexercise.ongoingrecords'), value: "ongoing", width: "200px" },
        { text: this.$t('pmreviewexercise.completedrecords'), value: "completed", width: "200px" },
      ],
      dataItems: [],
      rankMapSet: [],
      rankMapSetList: [],
      assessmentType: [],
      assessmentTypeList: [],
      statusList: [],

      loading: false,
      errMsg: "",
        search: this.$route.params.search,
    };
  },

  methods: {
    async getReviewExercise() {
      const vm = this;

      // Set loading state to true
      this.loading = true;

      try {
        // Fetch data from the store
        const res = await this.$store.dispatch('get', {url: "/reviewexercise/all"});

        vm.dataItems = res.data.rec;

        // Process dataItems
        for (let i = 0; i < vm.dataItems.length; i++) {
          // Format startdate if it exists
          if (vm.dataItems[i].startdate) {
            vm.dataItems[i].startdate = moment(vm.dataItems[i].startdate).format('YYYY-MM-DD');
          }

          // Format enddate if it exists
          if (vm.dataItems[i].enddate) {
            vm.dataItems[i].enddate = moment(vm.dataItems[i].enddate).format('YYYY-MM-DD');
          }

          // Map pmrankmaptext
          if (vm.dataItems[i].pmrankmapsetid){
            let item = this.rankMapSetList.find((item) => item.value === vm.dataItems[i].pmrankmapsetid);
            vm.dataItems[i].pmrankmaptext = item.text;
          }

          // Map pmstatus
          if (vm.dataItems[i].statusid){
            let item = this.statusList.find((item) => item.value === vm.dataItems[i].statusid);
            vm.dataItems[i].status = item.text;
          }

          //Map assessmenttext
          if (vm.dataItems[i].assessmentid){
            let item2 = this.assessmentTypeList.find((item2) => item2.value === vm.dataItems[i].assessmentid);
            vm.dataItems[i].assessmenttext = item2.text;
          }

          //Type
          if(vm.dataItems[i].formtype === 'R'){
            vm.dataItems[i].formtypetext = 'Rank';
          } else if(vm.dataItems[i].formtype === 'G'){
            vm.dataItems[i].formtypetext = 'Grid';
          }

          this.$set(vm.dataItems[i], 'initiated', 0);
          this.$set(vm.dataItems[i], 'ongoing', 0);
          this.$set(vm.dataItems[i], 'completed', 0);

          const totalRecords = await this.loadRecords(vm.dataItems[i].id, i);
          //Because it's using await so loading time might be slow, so using set is more reactive setting normally for Vue
          this.$set(vm.dataItems[i], 'totalRecords', totalRecords);

        }
      } catch (err) {
        // Handle error
        vm.errMsg = err;
      } finally {
        // Set loading state to false after processing is done
        vm.loading = false;
      }
    },

    loadRecords(id, index) {
      const vm = this;
      return this.$store.dispatch('get', { url: "/reviewexercise/staff/" + id })
        .then(function (res) {
          res.data.rec.forEach((item) => {
            if (item.statusid === 4) {
              vm.$set(vm.dataItems[index], 'initiated', vm.dataItems[index].initiated + 1);
            } else if (item.statusid === 5) {
              vm.$set(vm.dataItems[index], 'ongoing', vm.dataItems[index].ongoing + 1);
            } else if (item.statusid === 6) {
              vm.$set(vm.dataItems[index], 'completed', vm.dataItems[index].completed + 1);
            }
          });
          return res.data.rec.length;  // Return the totalRecords count
        })
        .catch(function (err) {
          vm.errMsg = err;
          return 0; // Return 0 if there's an error
        });
    },


    loadStatus() {
        const vm = this;
        return this.$store.dispatch('get', {url: "/reviewexercise/status/all"})
        .then(function (res) {
            vm.status = res.data.rec;
    
            for (let i = 0; i < vm.status.length; i++) {
                vm.statusList.push({
                text: vm.status[i].statusdesc,
                value: vm.status[i].id,
                });
            }
            })
        .catch(function (err) {
            vm.errMsg = err;
        });
    },

    loadRankMapSet() {
        const vm = this;

        return this.$store.dispatch('get', {url: "/rankmapset/active/all"})
        .then(function (res) {
          vm.rankMapSet = res.data.rec;

          for (let i = 0; i < vm.rankMapSet.length; i++) {
              vm.rankMapSetList.push({
              text: vm.rankMapSet[i].rankmapset,
              value: vm.rankMapSet[i].id,
              });
          }
        })
        .catch(function (err) {
            vm.errMsg = err;
        });
    },

    loadAssessmentType() {
        const vm = this;

        return this.$store.dispatch('get', {url: "/assessment/all"})
        .then(function (res) {
          vm.assessmentType = res.data.rec;
          for (let i = 0; i < vm.assessmentType.length; i++) {
              vm.assessmentTypeList.push({
              text: vm.assessmentType[i].assessmentcode,
              value: vm.assessmentType[i].id,
              });
          }
        })
        .catch(function (err) {
            vm.errMsg = err;
        });
    },

    advanceEditItemHandler(item) {
      const advanceItem = this.dataItems.find(dataItem => dataItem.id === item.id);
      this.$router.push({ name: "reviewexercisestaff", params: { id: item.id, item: advanceItem } });
    },


    editItemHandler(item) {
      const advanceItem = this.dataItems.find(dataItem => dataItem.id === item.id);
      this.$router.push({ name: "reviewexerciseedit", params: { id: item.id, item: advanceItem} });
    },

    deleteItemHandler(item){
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
          return false;
      }

      if (confirm(this.$t('pmreviewexercise.deleteexercise', { code: item.reviewcode }))) {
          this.$store.dispatch('delete', {
              url: "/reviewexercise/" + item.id
          })
          .then((res) => {
          if (res.data.error) {
              vm.isErr = !vm.isErr;
              vm.errMsg = res.data.error;
          } else {
              vm.getReviewExercise();
          }
          })
          .catch((err) => {
              vm.isErr = !vm.isErr;
              vm.errMsg = err;
          });
      }
    },

    newRecordHandler() {
      this.$router.push({ name: "reviewexercisenew" });
    },
  },
  mounted() {
    Promise.all([ this.loadRankMapSet(), this.loadAssessmentType(), this.loadStatus()])
        .then(() => {
            // After loading dependencies, get Review Exercise
            return this.getReviewExercise();
        })
        .then(() => {
            // Once everything is loaded, set loading to false
            this.loading = false;
        })
        .catch((err) => {
            // Handle any errors that occur during the process
            this.isErr = true;
            this.errMsg = err;
            console.error("Error:", err);
        });
  },
};
</script>